// To handle Scroll UP and DOWN
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
export class DDHammerConfig extends HammerGestureConfig {
    overrides = <any>{
        'pinch': { enable: false },
        'rotate': { enable: false }
    };
}

export const APP_PROVIDERS = [
    {
        provide: HAMMER_GESTURE_CONFIG,
        useClass: DDHammerConfig
    }
];
